import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Grid,
    Collapse,
    Menu,
    Tooltip
} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const getListItem = (
    onClick,
    icon,
    text,
    subSections,
    subSectionOpen,
    menuOpen,
    id,
    handleClick,
    endIcon
) => {
    return (
        <div id={id}>
            <ListItem
                onClick={
                    subSections?.length && !menuOpen
                        ? (event) => {
                              handleClick(event, id);
                          }
                        : onClick
                }
                button
                sx={{
                    '&:hover': {
                        background: (theme) => theme.palette.navbar.backgroundHover
                    },
                    boxShadow:
                        subSectionOpen && subSections?.length && menuOpen
                            ? '0px 3px 3px 0px rgb(0 0 0 / 25%)'
                            : '',
                    zIndex: 1,
                    p: 1
                }}>
                <ListItemIcon sx={{ fill: '#fff', color: '#fff', minWidth: '40px' }}>
                    {icon}
                </ListItemIcon>
                <ListItemText
                    primaryTypographyProps={{
                        variant: 'body2',
                        sx: { fontSize: '0.95rem' }
                    }}
                    style={{ fontWeight: 'bold' }}
                    primary={text}
                />
                <ListItemIcon sx={{ fill: '#fff', color: '#fff', minWidth: '40px' }}>
                    {endIcon}
                </ListItemIcon>
                {!!subSections?.length && (
                    <ListItemIcon
                        sx={{
                            color: '#fff',
                            justifyContent: 'flex-end'
                        }}>
                        {subSectionOpen ? (
                            <ExpandLessIcon color={'inherit'} />
                        ) : (
                            <ExpandMoreIcon color={'inherit'} />
                        )}
                    </ListItemIcon>
                )}
            </ListItem>
        </div>
    );
};

function SideMenuContent({ sideMenuItems, menuOpen }) {
    const [anchorEl, setAnchorEl] = useState({});
    const handleClick = (event, id) => {
        let obj = { ...anchorEl };
        obj[id] = event.currentTarget;
        setAnchorEl(obj);
    };
    const handleClose = () => {
        setAnchorEl({});
    };

    return (
        <>
            {sideMenuItems && (
                <Grid container>
                    <Grid item xs={12}>
                        <List sx={{ p: 1 }}>
                            {sideMenuItems.map(
                                (
                                    {
                                        key,
                                        icon,
                                        onClick,
                                        text,
                                        subSections,
                                        subSectionOpen,
                                        id,
                                        endIcon
                                    },
                                    i
                                ) => (
                                    <React.Fragment key={`${key}-${i}`}>
                                        {menuOpen ? (
                                            getListItem(
                                                onClick,
                                                icon,
                                                text,
                                                subSections,
                                                subSectionOpen,
                                                menuOpen,
                                                id,
                                                null,
                                                endIcon
                                            )
                                        ) : (
                                            <Tooltip title={text} placement="right" arrow>
                                                {getListItem(
                                                    onClick,
                                                    icon,
                                                    text,
                                                    subSections,
                                                    subSectionOpen,
                                                    menuOpen,
                                                    id,
                                                    handleClick,
                                                    endIcon
                                                )}
                                            </Tooltip>
                                        )}
                                        {subSections && menuOpen && (
                                            <Collapse
                                                in={subSectionOpen}
                                                timeout="auto"
                                                unmountOnExit>
                                                <List
                                                    sx={{
                                                        background: (theme) =>
                                                            theme.palette.navbar.background,
                                                        boxShadow:
                                                            'inset 0px -1px 3px 0px rgb(0 0 0 / 25%)'
                                                    }}>
                                                    {subSections?.map(
                                                        ({
                                                            key: subKey,
                                                            text: subtext,
                                                            onClick: subClick,
                                                            path,
                                                            icon,
                                                            id,
                                                            endIcon
                                                        }) => (
                                                            <ListItem
                                                                id={id}
                                                                button
                                                                key={subKey}
                                                                onClick={subClick}
                                                                sx={{
                                                                    borderLeft: (theme) =>
                                                                        window.location.pathname ===
                                                                        path
                                                                            ? `4px solid ${theme.palette.primary.main}`
                                                                            : '',
                                                                    pl: icon
                                                                        ? 4
                                                                        : window.location
                                                                              .pathname === path
                                                                        ? 5.3
                                                                        : 6,
                                                                    '&:hover': {
                                                                        background: (theme) =>
                                                                            theme.palette.navbar
                                                                                .backgroundHover
                                                                    },
                                                                    background:
                                                                        window.location.pathname ===
                                                                        path
                                                                            ? (theme) =>
                                                                                  theme.palette
                                                                                      .navbar
                                                                                      .backgroundHover
                                                                            : (theme) =>
                                                                                  theme.palette
                                                                                      .navbar
                                                                                      .background
                                                                }}>
                                                                {icon ? (
                                                                    <ListItemIcon
                                                                        sx={{
                                                                            fill: '#fff',
                                                                            color: '#fff',
                                                                            minWidth: '40px'
                                                                        }}>
                                                                        {icon}
                                                                    </ListItemIcon>
                                                                ) : null}
                                                                <ListItemText
                                                                    primaryTypographyProps={{
                                                                        id: id,
                                                                        variant: 'body2'
                                                                    }}
                                                                    style={{ fontWeight: 'bold' }}
                                                                    primary={subtext}
                                                                />
                                                                {endIcon ? (
                                                                    <ListItemIcon
                                                                        sx={{
                                                                            fill: '#fff',
                                                                            color: '#fff',
                                                                            minWidth: '40px'
                                                                        }}>
                                                                        {endIcon}
                                                                    </ListItemIcon>
                                                                ) : null}
                                                            </ListItem>
                                                        )
                                                    )}
                                                </List>
                                            </Collapse>
                                        )}
                                        {subSections && !menuOpen && (
                                            <Menu
                                                anchorEl={anchorEl[id]}
                                                open={!!anchorEl[id]}
                                                onClose={handleClose}
                                                onClick={handleClose}
                                                PaperProps={{
                                                    elevation: 0,
                                                    sx: {
                                                        overflow: 'visible',
                                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                        mt: 1.5,
                                                        color: (theme) =>
                                                            theme.palette.navbar.color,
                                                        background: (theme) =>
                                                            theme.palette.navbar.backgroundHover,
                                                        '&:before': {
                                                            content: '""',
                                                            display: 'block',
                                                            position: 'absolute',
                                                            top: 15,
                                                            left: -5,
                                                            width: 10,
                                                            height: 10,
                                                            background: (theme) =>
                                                                theme.palette.navbar
                                                                    .backgroundHover,
                                                            transform:
                                                                'translateY(-50%) rotate(45deg)',
                                                            zIndex: 0
                                                        }
                                                    }
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 60
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                }}>
                                                <List>
                                                    {subSections?.map(
                                                        ({
                                                            key: subKey,
                                                            text: subtext,
                                                            onClick: subClick,
                                                            id
                                                        }) => (
                                                            <ListItem
                                                                button
                                                                key={subKey}
                                                                id={id}
                                                                onClick={subClick}>
                                                                <ListItemText
                                                                    primaryTypographyProps={{
                                                                        variant: 'body2'
                                                                    }}
                                                                    style={{ fontWeight: 'bold' }}
                                                                    primary={subtext}
                                                                />
                                                            </ListItem>
                                                        )
                                                    )}
                                                </List>
                                            </Menu>
                                        )}
                                    </React.Fragment>
                                )
                            )}
                        </List>
                    </Grid>
                </Grid>
            )}
        </>
    );
}

SideMenuContent.propTypes = {
    sideMenuItems: PropTypes.arrayOf(PropTypes.object),
    menuOpen: PropTypes.bool
};

SideMenuContent.defaultProps = {
    sideMenuItems: null,
    menuOpen: false
};

export default SideMenuContent;
